import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Briefcase, Landmark, Building2, Scale } from 'lucide-react';
import Navbar from '../components/Navbar';
import PageHero from '../components/PageHero';
import Reviews from '../components/Reviews';
import FAQ from '../components/FAQ';
import { ContactSection, Footer } from '../components/Footer';
import { startupServices } from '../data/startupServices';

const ICON_MAP = {
  'company-incorporation': Briefcase,
  'income-tax-filing': Landmark,
  'msme-udyam': Building2,
  'legal-drafting': Scale,
};

export default function StartupCompliancePage() {
  useEffect(() => {
    document.title = 'Startup Registration & Compliance | EasyWorks';
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className="min-h-screen bg-[#FAF2E8] font-[Inter]" data-testid="startup-compliance-page">
      <Navbar />
      <PageHero
        eyebrow="Startup & Compliance"
        headline="Every filing,"
        headlineAccent="every deadline — handled"
        description="From company registration to Udyam, income tax and legal drafting — a single team, transparent pricing, zero late-fee penalties."
        category="startup"
        subtype="General"
        service="Startup & Compliance"
        formTitle="Get a startup quote"
        formTestId="startup-quote-form"
      />

      <section className="bg-white py-16 md:py-20">
        <div className="max-w-7xl mx-auto px-5 lg:px-10">
          <div className="text-xs uppercase tracking-wider text-[#F39200] font-semibold mb-3">Our services</div>
          <h2 className="text-3xl md:text-4xl font-extrabold text-neutral-900">Pick the service you need</h2>
          <div className="mt-8 grid md:grid-cols-2 gap-5">
            {startupServices.map((s) => {
              const Icon = ICON_MAP[s.slug] || Briefcase;
              return (
                <Link
                  key={s.slug}
                  to={`/startup-and-compliance/${s.slug}`}
                  data-testid={`startup-service-${s.slug}`}
                  className="group bg-[#FAF2E8]/60 border border-black/5 rounded-2xl p-7 hover:border-[#F39200] hover:shadow-md transition-all flex flex-col"
                >
                  <div className="w-12 h-12 rounded-xl bg-white shadow-sm text-[#F39200] flex items-center justify-center">
                    <Icon size={22} />
                  </div>
                  <div className="mt-4 text-xl font-bold text-neutral-900">{s.title}</div>
                  <div className="mt-1 text-xs uppercase tracking-wide text-[#F39200] font-semibold">{s.tagline}</div>
                  <p className="mt-3 text-sm text-neutral-600 leading-relaxed flex-1">{s.short}</p>
                  <div className="mt-5 flex items-center justify-between">
                    <div className="text-sm font-bold text-neutral-900">{s.price}</div>
                    <span className="inline-flex items-center gap-1 text-sm font-semibold text-[#F39200] group-hover:gap-2 transition-all">
                      Learn more <ArrowRight size={16} />
                    </span>
                  </div>
                </Link>
              );
            })}
          </div>
        </div>
      </section>
      <Reviews />
      <FAQ />
      <ContactSection />
      <Footer />
    </div>
  );
}
